import { apiRequest } from './client';
import type { NutritionDetail } from './types';

export async function getNutritionDetail(): Promise<NutritionDetail> {
  return apiRequest<NutritionDetail>('/integrations/nutrition/detail');
}
